<template>
  <div class="mb-5">
    <!-- Breadcrumb -->
    <div class="container">
      <div class="section breadcrumb" >
        <div class="header-wrapper">
          <b-breadcrumb
              align="is-left"
          >
              <b-breadcrumb-item tag='router-link' to="/happenings">Happenings</b-breadcrumb-item>
              <b-breadcrumb-item tag='router-link' to="/happenings/gallery" active>Gallery</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="pb-title">GALLERY</div>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="container">
      <div class="section py-5">
        <div class="columns is-12 is-mobile is-tablet is-desktop mr-0 gallery-columns">
          <!-- Month Filter -->
          <div class="column is-12-mobile is-12-tablet is-2-desktop pr-0">
            <b-field class="bg-white">
                <b-select placeholder="Select month" v-model="inputMonth">
                  <option style="color: #363636 !important" value="" selected>Select Month</option>
                    <option
                        v-for="month, index in monthOptions"
                        :value="month.value"
                        :key="index">

                        {{ month.label }}
                    </option>
                </b-select>
              </b-field>
          </div>
          <!-- Year Filter -->
          <div class="column is-12-mobile is-12-tablet is-2-desktop pr-0">
            <b-field class="bg-white">
              <b-select placeholder="Select year" v-model="inputYear">
                  <option style="color: #363636 !important" value="" selected>Select Year</option>
                  <option
                      v-for="year, index in years"
                      :value="year"
                      :key="index">

                      {{ year}}
                  </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12-mobile is-12-tablet is-6-desktop pr-0">
            <template>
              <b-autocomplete
                  rounded
                  v-model="searchInput"
                  :data="filteredDataArray"
                  placeholder="Search by event name"
                  icon-right="magnify"
                  clearable
                  @typing="filterAnnouncement('typing')"
                  @select="filterAnnouncement('select')">
                  <template #empty>No results found</template>
              </b-autocomplete>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Month tab-->
    <div class="container">

      <div class="section py-1" v-for="item, index in getFilteredGalleryData" :key="index">
        <div class="month-tab bold-l2">
            {{ formatDate(item[0].data.date) }} 
          </div>
        <hr style="background-color: #2B2D47">
        <div>
          <!-- <div v-for="data in getDataByMonthsYear(monthYear)"> -->
            <div> 
              <div v-for="v,k in item" :key="k">
                <div class="has-text-left mt-4 mb-6">
                  <h1 class="pb-title has-text-left">{{v.data.title}}</h1>
                  <p class="body-1 mt-4" style="white-space: pre-line;">{{v.data.description}}</p>
                </div>
                <!-- {{  v.data.images.data }} -->
                <div class="columns is-mobile is-tablet is-desktop is-multiline has-text-left pb-0">
                  <div class="column is-4-desktop is-4-tablet is-6-mobile" v-for="data,g in v.data.images.data.slice(0, item[k].gallerySize)" :key="g">
                    <figure class="image is-5by4">
                      <img :src=" data.attributes.url" @click="viewDetails(index, k, data.attributes.url)" style="" class="carousel-image"/>
                    </figure>
                  </div> 
                </div>
                 <!-- VIEW ALL BUTTON -->
                <div class="pb-6 mt-6 mb-3 pr-6" v-if="v.data.images.data.length > 6 && item[k].hideButton" style="position: relative;">
                  <a class="text-link" @click="loadData(index, k)" style="position: inherit; color: #730039 !important;">
                    View All
                  </a>
                </div>
                <div v-else class="mb-6" ></div>
              </div>
             
            </div>
          <!-- </div> -->
        </div>
        <div v-if="getFilteredGalleryData.length == 0" style="min-height: 100px; margin-inline: auto;">
          No results of galleries found.
        </div>
      </div>


      <!-- <div class="section py-1" v-for="monthYear, id in getMonthsYear">
        <div class="is-flex is-justify-content-space-between">
          <div class="month-tab pt-2 bold-l2">
            {{ monthYear.date }} {{ monthYear.monthName.toUpperCase() }} {{ monthYear.year }}
          </div>
        </div>
        <hr style="background-color: #2B2D47; padding: 0; margin: 0;">

        <div v-if="galleries.length > 0">
          <div v-for="data in getDataByMonthsYear(monthYear)">
            <div v-for="(gallery, index) in galleries" :key="index"> 
              <div>
                <div class="has-text-left mt-4 mb-6">
                  <h1 class="pb-title has-text-left">{{gallery.attributes.title}}</h1>
                  <p class="body-1 mt-4" style="white-space: pre-line;">{{gallery.attributes.description}}</p>
                </div>
                <div class="columns is-mobile is-tablet is-desktop is-multiline has-text-left pb-0">
                  <div class="column is-4-desktop is-12-mobile" v-for="(image, k) in gallery.attributes.images.data.slice(0, gallery.gallerySize)" :key="k">
                    <img :src="image.attributes.url" @click="viewDetails(index)" style="" class="carousel-image"/>
                  </div>
                </div>
              </div>
               VIEW ALL BUTTON
              <div class="pb-6 mt-6 mb-3 pr-6" v-if="gallery.attributes.images.data.length > 6 && gallery.hideButton" style="position: relative;">
                <a class="text-link" @click="loadData(index)" style="position: inherit; color: #730039 !important;">
                  View All
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="getFilteredGalleryData.length == 0" style="min-height: 100px; margin-inline: auto;">
          No results of galleries found.
        </div>
      </div> -->

      <!-- Modal (hidden) -->
      <b-modal v-model="isModalActive" scroll="keep">
        <div>
          <b-carousel
            v-if="activeImages.length > 0"
            :autoplay="false"
            with-carousel-list
            :indicator="false"
            :overlay="false"
            :arrow="true"
            icon-prev="menu-left" 
              icon-next="menu-right"
              v-model="activeImageIndex"
            @click="switchGallery(true)">
            <!-- show the big image -->
            <b-carousel-item id="bigImage" v-for="(item, index) in activeImages" :key="index">
                <b-image class="image" :src="item.image"></b-image>
            </b-carousel-item>
            <!-- Show the grid gallery -->
            <template #list="props">
              <div class="thumbnail-wrapper">
                <b-carousel-list
                    v-model="props.active"
                    :data="activeImages"
                    v-bind="al"
                    :arrow="true"
                    icon-prev="menu-left" 
                    icon-next="menu-right"
                    @switch="props.switch($event, false)"
                    as-indicator />
              </div>
            </template>
          </b-carousel>
          <hr class="divider">
          <div class="carousel-flexbox overlay-content color-white has-text-left py-5" style="padding-inline: 2em;">
            <p class="pb-title">{{ activeData.title }}</p>
            <p class="pb-subtitle bold-0 mt-5">{{ activeData.description }}</p>
            <p class="pb-subtitle bold-0 mt-5 mb-4" style="white-space: pre-line;">Published on date {{formatDate(activeData.date)}}</p>
          </div>
        </div>
      </b-modal>

      
      <!-- <b-modal v-model="isModalActive" scroll="keep" v-for="(gallery, index) in galleries" :key="index">
        <div>
          <b-carousel :indicator-inside="false" :icon-prev="iconPrev" :icon-next="iconNext">
            show the big image
            <b-carousel-item v-for="(image, index) in gallery.attributes.images.data.slice(0,6)" :key="index">
                <b-image class="image" :src="image.attributes.url"></b-image>
            </b-carousel-item>
            Show the grid gallery
            <template #indicators="props">
              <div v-for="(image, index) in gallery.attributes.images.data.slice(0,1)" :key="index">
                <img :draggable="false" :src="image.attributes.url" :title="image.index">
              </div>
            </template>
          </b-carousel>
          <hr class="divider">
          <div class="carousel-flexbox overlay-content color-white has-text-left py-5" style="padding-inline: 2em;">
            <p class="pb-title">{{ gallery.attributes.title }}</p>
            <p class="pb-subtitle bold-0 mt-5">{{ gallery.attributes.description }}</p>
            <p class="pb-subtitle bold-0 mt-5 mb-4" style="white-space: pre-line;">Published on date {{formatDate(gallery.attributes.date)}}</p>
          </div>
        </div>
      </b-modal> -->
    </div>

    <div class="is-flex is-justify-content-end">
      <ScrollTop />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import ScrollTop from '../../components/ScrollTop.vue';

  export default {
    components: { ScrollTop },
    data() {
      return {
        gallery: false,
        activeImageIndex:0,
        hideButton: true,
        dataLength: 0,
        gallerySize: 3,
        isModalActive: false,
        galleries: [],
        galleryList: [],
        galleryTitleList: [],
        activeData: {},
        activeImages: [],
        counter: 0,
        iconPrev: 'menu-left',
        iconNext: 'menu-right',
        layout: 'list', //default is list
        // Filter props
        inputMonth: '',
        inputYear: '',
        inputRanking: '',
        selectedMonth: '',
        selectedYear:'',
        inputMonthIndex: '',
        monthOptions: [
            {
              label: 'January',
              value: '1'
            },
            {
              label: 'February',
              value: '2'
            },
            {
              label: 'March',
              value: '3'
            },
            {
              label: 'April',
              value: '4'
            },
            {
              label: 'May',
              value: '5'
            },
            {
              label: 'June',
              value: '6'
            },
            {
              label: 'July',
              value: '7'
            },
            {
              label: 'August',
              value: '8'
            },
            {
              label: 'September',
              value: '9'
            },
            {
              label: 'October',
              value: '10'
            },
            {
              label: 'November',
              value: '11'
            },
            {
              label: 'December',
              value: '12'
            },
          ],
        fullMonths: [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ],
        years: [],
        rankings: ["Wealth Associate", "Wealth Manager", "Senior Wealth Partner", "Managing Partner"],
        paramRank: '',
        searchInput: '',
        al: {
          itemsToShow: 6,
      },
      }
    },
    mounted() {
      let year = dayjs().year() - 3;

      // this.generateYears()

      // set campaign first load (more than current month)
      this.$httpClientCMS({
        method: 'GET',
        url: 'api/galleries?populate=*&sort=date:desc'
      })
      .then(resp => {
        let data = resp.data.data
        var popData = []
        for(let x=0; data.length > x; x++){
          
          //split day,month,year for populate
          let split = (data[x].attributes.date).split('-')
          let newData = {
            month: this.fullMonths[parseInt(split[1]) -1],
            monthNum: parseInt(split[1]),
            year: split[0],
            gallerySize: 6,
            date: data[x].attributes.date,
            data: data[x].attributes,
            hideButton: true
          }

          popData.push(newData)
        }

        //list all year in data.attributes.date
        let yearList = data.map(i => i.attributes.date.split('-')[0])
        //remove duplicate year
        let uniqueYear = [...new Set(yearList)]
        //sort year
        let sortedYear = uniqueYear.sort((a, b) => b - a)
        //set year
        this.$set(this, "years", sortedYear);

        //grouped by month
        let grouped = this.groupBy(popData, 'date')

        this.galleries = grouped

        this.dataLength = data.length;
        this.$set(this, "galleryList", grouped);
        this.galleryTitleList = data.map(i => i.attributes.title);

      })

      // this.$httpClientCMS({
      //   method: 'GET',
      //   url: 'api/galleries?populate=*&&sort=date:desc&filters[date][$gte]=' + year + '-01-01'
      // })
      // .then(resp => {
      //   let galleries = resp.data.data;

      //   let newGallery = []

      //   for(let x=0; galleries.length >x; x++) {
      //     newGallery.push({
      //       ...galleries[x],
      //       hideButton: true,
      //       gallerySize: 6,
      //     })
      //   }
      //   this.$set(this, 'galleries', newGallery);
      //   this.dataLength = galleries.length;
      //   this.$set(this, "galleryList", galleries);
      //   this.galleryTitleList = galleries.map(i => i.attributes.title);

      //   this.generateYears()
      //   // this.generateRanking()
      // })
      // .catch((error) => {
      //   this.$router.push('maintenance');
      // });
    },
    methods:{
      groupBy(objectArray, property) {
        return objectArray
          .reduce((acc, obj) => {
            const key = obj[property];
            const curGroup = acc[key] ?? [];

            return { ...acc, [key]: [...curGroup, obj] };
          }, {});
      },
      switchGallery(value) {
          this.gallery = value
          if (value) {
              document.documentElement.classList.add('is-clipped')
          } else {
              document.documentElement.classList.remove('is-clipped')
          }
      },
      switchImage(value) {
          this.activeImageIndex = value;
      },
      filterAnnouncement: debounce(function (type) {
        let filteredList = [];
        if(this.searchInput === ''){
          filteredList = this.galleries;
        }
        else if(type === 'select'){
          filteredList = this.galleries.filter(i => i.data.attributes.title === this.searchInput);
        }else if(type === 'typing'){
          filteredList = this.galleries.filter((option) => {
            return option.data.attributes.title
              .toString()
              .toLowerCase()
              .indexOf(this.searchInput.toLowerCase()) >= 0
          })
        }
        this.$emit('set-content-array', filteredList);
      }, 500),
      formatMonthAndYear(date){
        const tempDate = new Date(date);
        let formattedDate = this.fullMonths[tempDate.getMonth()] + " " + tempDate.getFullYear()
        return formattedDate;
      },
      loadData(k, f){
        if(this.inputMonth || this.inputYear || this.inputRanking) {
          this.contentList[k][0].campaignSize = this.contentList[k].length
          this.contentList[k][0].hideButton = false
        }
        else {
          this.galleries[k][f].gallerySize = (this.galleries[k][f].data.images.data).length
          this.galleries[k][f].hideButton = false
        }
      },
      viewDetails(k, f, clickedImageUrl){
        // if (this.isAuthenticated) {
        //   localStorage.setItem("trainingDate", trainingDate);
        //   localStorage.setItem("viewTraining", 'true');
        //   return this.$router.push({ name: 'consultant-training' })
        // }else{
        //   this.isModalActive = true;
        // }
        let images = this.galleries[k][f].data.images.data
        let popImage = []
        for(let x=0; images.length >x; x++) {
          popImage.push({
            name: images[x].attributes.name,
            image: images[x].attributes.url,
          })
        }

        const clickedImageIndex = popImage.findIndex(item => item.image === clickedImageUrl);
  if (clickedImageIndex >= 0) {
    this.activeImageIndex = clickedImageIndex;
  }
        this.$set(this, "activeImages", popImage)
        this.$set(this, "activeData", this.galleries[k][f].data)
        if(this.activeImages.length > 0){
          this.isModalActive = true;
        }
      },
      // setTraining(filteredList){
      //   this.galleries = filteredList;
      //   this.dataLength = filteredList.length;
      //   if(this.gallerySize >= this.dataLength){
      //     this.hideButton = false;
      //   }else{
      //     this.hideButton = true;
      //   }
      // },
      // setGalleryAndDataLength(filteredList){
      //   this.galleries = filteredList;
      //   this.dataLength = filteredList.length;
      // },
      // setIndex(index){
      //   this.counter = index;
      //   return index;
      // },
      generateYears(){
        var today = dayjs();
        let currentYear = parseInt(dayjs(today).format('YYYY'));  // set default dropdown year
        for(let i=0; i<3; i++){
          this.years[i] = (currentYear - i).toString();
        }
        // this.inputYear = this.years[0];
        // let currentMonth = dayjs(today).format('MMMM');
        // this.inputMonth = currentMonth;     // set default dropdown month
        // this.inputMonthIndex = dayjs(today).format('M');
      },
      // generateRanking(){
      //   this.inputRanking = 'Select Ranking';
      // },
      formatDate(monthYear){
        const tempDate = new Date(monthYear);

        // let formattedDate = tempDate.getDate() + " " + this.fullMonths[tempDate.getMonth()] + " " + tempDate.getFullYear();

        let formattedDate = dayjs(tempDate).format('DD MMMM YYYY').toUpperCase()
        return formattedDate;
      },
      // get data by month and year
      getDataByMonthsYear(monthYear) {
        return this.getFilteredGalleryData.filter(webinar => {
          const setMonth = dayjs(webinar.attributes.date).month() + 1
          return dayjs(webinar.attributes.date).year() === monthYear.year && setMonth === monthYear.month}
        )
      },
    },
    computed: {
      filteredDataArray() {
        return this.galleryTitleList.filter((option) => {
          return option
            .toString()
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) >= 0
        })
      },
      isAuthenticated() {
        return this.$store.getters['auth/isAuthenticated']
      },
      
      getFilteredGalleryData() {
        var filteredGallery = this.galleries

        if(this.inputMonth || this.inputYear || this.searchInput) {

          filteredGallery = this.galleryList

           //filter by month
          if(this.inputMonth) {

            let filtered = []
            for(let x in filteredGallery){
              for(let y=0; filteredGallery[x].length > y; y++){
                if((new Date(x).getMonth()) +1 == this.inputMonth) {
                  filtered.push(filteredGallery[x][y])
                }
              }
            }

            filteredGallery = this.groupBy(filtered, 'date')
          }

          //filter by year
          if(this.inputYear) {
            let filtered = []
            for(let x in filteredGallery){
              for(let y=0; filteredGallery[x].length > y; y++){
                if(new Date(x).getFullYear() == this.inputYear) {
                  filtered.push(filteredGallery[x][y])
                }
              }
            }

            filteredGallery = this.groupBy(filtered, 'date')
          }

          //filter by event
          if(this.searchInput) {
            let filtered = []
            for(let x in filteredGallery){
              for(let y=0; filteredGallery[x].length > y; y++){
                if(filteredGallery[x][y].data.title == this.searchInput) {
                  filtered.push(filteredGallery[x][y])
                }
              }
            }


            filteredGallery = this.groupBy(filtered, 'date')
          }

        }

        return filteredGallery
      },
    }
  }
</script>

<style scoped lang="scss">
@import '../styles/font.scss';

:deep() {

  .carousel {

    .carousel-items {
      .carousel-item {
        .image {
          padding-top: 60%;
          img {
            bottom: 0;
            left: 0;
            position: absolute;
            height: 100%;
            right: 0;
            top: 0;
          }
        }
      }
   }

   .carousel-list {
    position: static;
    &.has-shadow {
      box-shadow: none;
    }
   }
   .carousel-slides {
    // overflow: hidden !important;
    .carousel-slide {
      // width: 130px !important;
      padding-right: 1rem;
      .image {
        padding-top: 100%;
        img {
          bottom: 0;
          left: 0;
          position: absolute;
          height: 100%;
          right: 0;
          top: 0;
        }
      }
    }
   }

   .carousel-items {
    .carousel-arrow {
      display: none ;
    }
   }

   .thumbnail-wrapper {

      .b-image-wrapper:hover{
        cursor:pointer;
      }

      .is-active{
        .b-image-wrapper{
          border: #3DBB95 5px solid;
        }
      }
      .carousel-arrow {
        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // z-index: 10;
        &.is-hovered {
          opacity: 1;
        }
        .icon {
          color: #363636;
          &.has-icons-left {
            // top: 90%;
            background-color: #FDB913;
            border-radius: 0;
            border: 0;
            width: 52px;
            height: 34px;
            left: -11%;
            z-index: 2;
            display: flex !important;
          }
          &.has-icons-right {
            // top: 90%;
            background-color: #FDB913;
            border-radius: 0;
            border: 0;
            width: 52px;
            height: 34px;
            right: -11%;
            // display: flex !important;
          }
        }
      }
    }

  }
  .modal-content {
    position: relative;
    overflow-x: hidden !important;
    &::-webkit-scrollbar {
      width: 5px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .modal-close {
    position: absolute;
    top: 0;
    right: 0;
    &::before, &::after {
      background-color: #363636;
    }
  }
}

:deep(){
  .control .input, .control .textarea, .control .select, .control select {
    background: white !important;
  }

  .searchbar-margin{
    margin-inline: 0em !important;
  }

  .searchbar-margin .control{
    padding: 0;
  }
  .modal-content {
    width: 100%;
    background-color: #2B2D47 !important;
  }

  .carousel-flexbox{
    padding-inline: 3rem !important;
  }
}

.thumbnail-wrapper {
  position: relative;
  margin: 2.5rem 8rem 1rem !important;
}



.gallery-columns{
  padding: 0px !important;
  align-items: center;
}
.b-tabs > nav{
  display: none;
}

h2{
  font-weight: 700;
  font-size: 23px;
  color: #323337;
  line-height: 30px;
}

.column{
  padding-left: 13px !important;
}

.text-link{
  text-decoration-line: underline;
  color: #2F469C;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  position: absolute;
  bottom: 0;
  left: 40px;
}

.join-now-btn{
  background-color: #730039;
  color: #FFFFFF;
}

.divider{
  background-color: #3DBB95;
  padding: 0 !important;
  width: 90% !important;
  margin: 0 auto;
}

// dropdown styling
.panel-block{
  border-bottom: none;
}
.dropdown-label{
  font-weight: 700;
  font-size: 20px;
  color: #323337;
}

.calendar-dropdown{
  justify-content:left;
  background: #FFFFFF;
  color: #363636;
  font-size: 16px !important;
  height: auto;
  cursor: pointer;
}

.dropdown-item-content{
  background: #FFFFFF;
  color: #363636;
}

a.dropdown-item{
  padding-left: 0px;
  background: #FFFFFF;
}

.collapse-button{
  font-size: 16px;
  color: #363636;
  background: #FFFFFF;
  border: 0;
  justify-content: left;
}

.collapse-button :hover{
  background: #FFFFFF;
}

:deep(){
  .carousel-image{
    max-width: 400px;
    width: 100%;
    max-height: 340px;
    height: 100%;
    object-fit: cover;
  }

  .carousel-image:hover{
    cursor:pointer;
  }

// modal gallery
  .carousel .carousel-indicator{
    max-width: 800px;
    width: 100%;
    padding: 2rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }
}

// tab
nav.tabs{
  display: none !important;
}

section.tab-content{
  padding: 0rem !important;
}

hr{
  padding: 4px !important;
  margin: 0 0 2.5rem;
}

:deep(){
  .dropdown-menu, .dropdown-content {
    padding: 0px !important;
    background: #FFFFFF;
  }

  .tabs ul{
    display: none;
  }

  section.tab-content{
    padding: 0;
  }

  .input.is-rounded{
    background-color: #FFFFFF !important;
  }
}

.month-tab{
  background-color: #2B2D47;
  color: #FFFFFF;
  width: 213px;
  height: 40px;
  text-align: center;
  padding: 10px 0 5px;
  margin-top: 2.5rem;
}

@media screen and (min-width:1601px){
  .month-tab{
    background-color: #2B2D47;
    color: #FFFFFF;
    width: 213px;
    // height: 50px;
  }
}

@media screen and (max-width:1290px) and (min-width: 1022px){
  .div{
    margin-left: 5px !important;
    margin-right: 0px !important;
  }
}

@media screen and (max-width:1023px) {
  .gallery-columns{
    display: flex;
    flex-direction: column;
  }

  .carousel-flexbox {
    padding: 1rem;
  }

  :deep(){

    // .carousel-slides {
    //   visibility: hidden !important;
    // }
    .searchbar-margin .control{
      width: 100%;
      margin-left: 0 !important;
    }

    .divider{
      display: none;
    }

    .thumbnail-wrapper {
      margin: 0 !important;
      .carousel-list {
        display: none;
      }
    }
    .carousel-items {
      padding-bottom: 4rem;
      .carousel-arrow {
        display: flex !important;
        &.is-hovered {
          opacity: 1;
        }
        .icon {
          color: #363636;
          &.has-icons-left {
            position: absolute;
            background-color: #FDB913;
            border-radius: 0;
            border: 0;
            top: unset !important;
            width: 30px !important;
            height: 30px !important;
            right: 10% !important;
            bottom: -3% !important;
            left: unset !important;
            display: flex !important;
          }
          &.has-icons-right {
            background-color: #FDB913;
            border-radius: 0;
            border: 0;
            top: unset !important;
            width: 30px !important;
            bottom: -3% !important;
            height: 30px !important;
            right: 6% !important;
            display: flex !important;
          }
        }
      }
    }
  }
}

@media (min-width: 500px ) and (max-width: 768px ){
  :deep(){
    .searchbar-margin .control{
      width: 100%;
      margin-left: 0 !important;
    }

    .divider{
      display: none;
    }
  }
}

@media (max-width: 600px) {
  .column.is-6-mobile {
    width: 100%;
  }
}

@media (max-width: 420px) {
  :deep(){
    .carousel-items {
      .carousel-arrow {
        .icon {
          color: #363636;
          &.has-icons-left {
            right: 12% !important;
            bottom: -3% !important;
          }
          &.has-icons-right {
            bottom: -3% !important;
            right: 6% !important;
          }
        }
      }
    }
  }
}

@media screen and (max-width:893px){
  .modal .animation-content .modal-card{
    width: auto !important;
    margin: 50px !important;
  }

  .div .modal-card-body{
    padding-top: 30px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .modal-icon{
    font-size: 18px;
    color: #5C5D64;
    margin-right: 5px !important;
    margin-left: 15px !important;
  }

  .subtitle{
    font-size: 13px;
  }

  .subtitle span{
    padding: 0px;
  }
}

@media screen and (max-width:768px){
  .column{
    float: none;
    position: static;
    min-height: auto;
    padding-left: 20px !important;
    border-top: 0px !important;
  }

  .text-link{
    position: static;
    bottom: auto;
    left: auto;
  }

  h2{
    margin-bottom: 10px;
  }

  .email-column{
    padding-left: 0px !important;
  }

  .title{
    margin-bottom: 10px !important;
  }

  .month-tab{
    background-color: #2B2D47;
    color: #FFFFFF;
    width: 50%;
    text-align: center;
  }
}

@media screen and (max-width: 425px) {
  .gallery-columns{
    flex-direction: column;
  }

}

@media (min-width: 1024px) and (max-width: 1407px) {
  :deep() {
    .thumbnail-wrapper {
      .carousel-arrow {
        &.is-hovered {
          opacity: 1;
        }
        .icon {
          color: #363636;
          &.has-icons-left {
            left: -9% !important;
          }
          &.has-icons-right {
            right: -9% !important;
          }
        }
      }
    }
  }
}

@media (min-width: 1661px) {
  :deep() {

    .thumbnail-wrapper {
      .carousel-arrow {
        &.is-hovered {
          opacity: 1;
        }
        .icon {
          color: #363636;
          &.has-icons-left  {
            left: -17% !important;
          }
          &.has-icons-right {
            right: -17% !important;
          }
        }
      }
    }
  }
}
</style>
